<div class="snackbar-container">
  <img [src]="data.icon" alt="Icon" class="snackbar-icon" [style.width.px]="data.iconSize" [style.height.px]="data.iconSize" />
  <span>{{ data.message }}</span>
</div>
